<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroAdmHotel />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroAdmHotel from "../Components/Cadastros/CadastroAdmHotel.vue";
export default {
  name: "RegisterHotel",
  components: {
    CadastroAdmHotel,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
